import { ConfigProvider } from "antd";
import React from "react";
import zhCN from "antd/es/locale/zh_CN";
import { StyleProvider, legacyLogicalPropertiesTransformer } from '@ant-design/cssinjs';

export function rootElement(element) {
    return <StyleProvider layer={false} hashPriority="high" transformers={[legacyLogicalPropertiesTransformer]} ><ConfigProvider

        theme={{
            components: {
                Button: {
                    textHoverBg: window.btnColor || "rgba(0,0,0,0.04)"
                },
            },
        }}
        locale={zhCN}>{element}</ConfigProvider></StyleProvider>
}